import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type MollakProxyMethod = 'GET' | 'POST';
export type MollakProxyEnvironment = 'Production' | 'Test';

export interface MollakProxyFormValue {
	method: MollakProxyMethod;
	endpointPath: string;
	environment: MollakProxyEnvironment;
	payload?: unknown;
}

export interface MollakProxyApiResponse {
	environment: MollakProxyEnvironment;
	status: number;
	data?: unknown;
	error?: unknown;
}

export interface MollakProxyExecutionResult extends MollakProxyApiResponse {
	correlationId?: string | null;
}

interface MollakProxyApiRequest {
	method: MollakProxyMethod;
	endpoint: string;
	environment: MollakProxyEnvironment;
	payload: unknown | null;
}

@Injectable( {
	providedIn: 'root',
} )
export class MollakProxyService {
	private readonly http = inject( HttpClient );

	private readonly endpoint = `${environment.apiURL}/internal/mollak-proxy`;

	executeProxyCall ( payload: MollakProxyFormValue ): Observable<MollakProxyExecutionResult> {
		const body: MollakProxyApiRequest = {
			method: payload.method,
			endpoint: payload.endpointPath,
			environment: payload.environment,
			payload: payload.payload ?? null,
		};

		return this.http.post<MollakProxyApiResponse>( this.endpoint, body, { observe: 'response' } )
			.pipe(
				map( ( response: HttpResponse<MollakProxyApiResponse> ) => {
					const responseBody = response.body ?? {
						environment: payload.environment,
						status: response.status,
					};
					return {
						...responseBody,
						correlationId: response.headers.get( 'x-correlation-id' ),
					};
				} ),
			);
	}
}
